<template>
  <div>
    <v-tooltip top>
      <v-btn slot="activator" flat icon @click.prevent="clickView()">
        <v-icon>visibility</v-icon>
      </v-btn>
      <span>Visualizar dados da tarefa</span>                  
    </v-tooltip>
    <v-dialog v-model="dialogViewTask" scrollable width="500px">
      <v-card justify-center v-if="dialogViewTask">
        <v-card-title>
          <span class="headline"><strong>Dados da Tarefa</strong></span>
          <v-tooltip bottom>
            <v-btn slot="activator" icon style="right: 0; top: 0; position: absolute" fab @click="dialogViewTask = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>    
            <v-flex xs12 sm2 class="my-1">
              <div class="p-label">Código</div>
              <div v-if="taskValues['identifier_sequence']" class="p-content-task break-word" style="white-space: pre-line;">{{taskValues['identifier_sequence']}}</div>
              <div v-else class="p-content-task"> </div>
            </v-flex>
            <v-flex xs12 sm10 class="my-1"> 
              <div class="p-label">Nome</div>
              <div class="p-content-task break-word" style="white-space: pre-line;">{{taskValues['id_text']}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Status</div>
              <div v-if="taskValues['status']" class="p-content-task break-word" :style="`color:${taskValues.status['color']}`">{{taskValues['status']['id_text']}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Urgencia</div>
              <div v-if="taskValues['urgency']" class="p-content-task break-word" :style="`color:${translate('value.task_urgency').find((val)=>{ return val.value === taskValues.urgency }).color_solid}`">{{translate('value.task_urgency').find((val)=>{ return val.value === taskValues.urgency }).text}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">{{taskValues.commitment === 1 ? 'Data de Compromisso' : translate('table.tasks.field.end')}}</div>
              <div class="p-content-task" v-if="taskValues.commitment === 1"> {{!taskValues.end ? moment(taskValues.begin).format("DD/MM/YYYY") : moment(taskValues.begin).format("DD/MM/YYYY HH:mm:ss") + ' até ' + moment(taskValues.end).format("DD/MM/YYYY HH:mm:ss")}}</div>
              <div v-else-if="taskValues.end" class="p-content-task"> {{moment(taskValues.end).format("DD/MM/YYYY HH:mm:ss")}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Equipe</div>
              <div class="p-content-task break-word">{{taskValues['team_id'] ? taskValues['team']['id_text'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Responsável</div>
              <div class="p-content-task break-word">{{taskValues['user_id'] ? taskValues['user']['id_text'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Cliente</div>
              <div class="p-content-task break-word">{{taskValues['client_id'] ? taskValues['client']['id_text'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Categoria</div>
              <div class="p-content-task break-word">{{taskValues['category_id'] ? taskValues['category']['id_text'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 class="my-1">
              <div class="p-label">Observação</div>
              <div v-html="taskValues.note ? taskValues.note : ' '" class="p-content-task break-word"></div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn round color="primary" dark @click="dialogViewTask = false">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /* eslint-disable no-useless-escape */
  export default {
    name: 'PViewtask',
    props: {
      task_id: {
        type: Number,
        default: 0
      }
    },
    data: function () {
      return {
        dialogViewTask: false,
        basePath: process.env.API,
        taskValues: {}
      }
    },
    methods: {
      clickView (id = this.task_id) {
        this.$store.commit('loader/change_dialog', true)
        let link = `api/task_view/${id}`
        this.$http.get(link).then(res => {
          this.taskValues = res.body
          this.dialogViewTask = true
          this.$store.commit('loader/change_dialog', false)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os dados da tarefa, reporte o erro.',
            color: 'error',
            dialog: true
          })
        })
      }
    }
  }
</script>

<style scoped>
  .p-label {
    font-size: 9pt;
    color: #1d1d1d;
    font-weight: 600;
    padding-left: 8px;
  }
  .p-content-task {
    font-size: 12pt;
    padding-left: 8px;
    /* font-weight: 600; */
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/PViewTask.vue